import { KeyboardEvent } from 'react';

export default function isCtrlPressed(event: KeyboardEvent<HTMLElement>) {
  return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform) ? event.metaKey : event.ctrlKey;
}
